<template>
  <GoldPriceTracker />
</template>

<script setup>
import GoldPriceTracker from './pages/ChinaGold.vue'
</script>
